import { IconChevronRight } from "@tabler/icons-react";
import type { ReactElement, ReactNode } from "react";
import styles from "./DrawerInspectorNavRow.module.css";

interface DrawerInspectorNavRowProps {
  label: string;
  onNavigate(): void;
  /** Drill-in rows show a trailing chevron; action menus omit it. */
  showChevron?: boolean;
}

interface DrawerInspectorNavRowListProps {
  children: ReactNode;
  className?: string;
}

const CHEVRON_SIZE = 20;

/** 48 px list-row tap targets — `<button>` for a11y, styled as flat nav rows. */
export function DrawerInspectorNavRow({
  label,
  onNavigate,
  showChevron = true
}: DrawerInspectorNavRowProps): ReactElement {
  return (
    <button type="button" className={styles.row} onClick={onNavigate}>
      <span className={styles.label}>{label}</span>
      {showChevron ? (
        <IconChevronRight
          className={styles.chevron}
          size={CHEVRON_SIZE}
          stroke={1.5}
          aria-hidden
        />
      ) : null}
    </button>
  );
}

/** Groups consecutive nav rows; drops the bottom divider on the last row when 2+. */
export function DrawerInspectorNavRowList({
  children,
  className
}: DrawerInspectorNavRowListProps): ReactElement {
  return (
    <div className={[styles.list, className].filter(Boolean).join(" ")}>
      {children}
    </div>
  );
}
